export const const_address_point_symbol = {
  type: "simple-marker",
  path:
    "M79,32c0-15.5-12.5-28-28-28s-28,12.5-28,28c0,4.4,1,8.5,2.9,12.3h0c0,0,0.1,0.2,0.3,0.6c0.2,0.4,0.4,0.7,0.6,1    c0.8,1.4,1.8,3.3,2.3,4.1c2.7,4.2,5.9,9.6,7.9,12.9c2.8,4.5,7.4,14,9.3,18.9c1.4,3.5,4.7,14.4,4.7,14.4s3.4-10.8,4.7-14.4    c1.9-4.9,6.5-14.5,9.3-18.9c2.1-3.3,5.2-8.7,7.9-12.9c0.5-0.8,1.6-2.7,2.3-4.1c0.2-0.3,0.4-0.7,0.6-1c0.2-0.4,0.3-0.6,0.3-0.6h0    C78,40.6,79,36.4,79,32z M51,50.7c-10.3,0-18.6-8.3-18.6-18.6c0-10.3,8.3-18.6,18.6-18.6c10.3,0,18.6,8.3,18.6,18.6    C69.7,42.3,61.3,50.7,51,50.7z",
  size: "36px",
  color: "#226abc",
  outline: { color: "#226abc", width: "1px" },
};

export const const_mapPnt = {
  type: "simple-marker",
  path:
    "M79,32c0-15.5-12.5-28-28-28s-28,12.5-28,28c0,4.4,1,8.5,2.9,12.3h0c0,0,0.1,0.2,0.3,0.6c0.2,0.4,0.4,0.7,0.6,1    c0.8,1.4,1.8,3.3,2.3,4.1c2.7,4.2,5.9,9.6,7.9,12.9c2.8,4.5,7.4,14,9.3,18.9c1.4,3.5,4.7,14.4,4.7,14.4s3.4-10.8,4.7-14.4    c1.9-4.9,6.5-14.5,9.3-18.9c2.1-3.3,5.2-8.7,7.9-12.9c0.5-0.8,1.6-2.7,2.3-4.1c0.2-0.3,0.4-0.7,0.6-1c0.2-0.4,0.3-0.6,0.3-0.6h0    C78,40.6,79,36.4,79,32z M51,50.7c-10.3,0-18.6-8.3-18.6-18.6c0-10.3,8.3-18.6,18.6-18.6c10.3,0,18.6,8.3,18.6,18.6    C69.7,42.3,61.3,50.7,51,50.7z",
  size: "24px",
  color: "#f50057",
  outline: { color: "#f50057", width: "1px" },
};

//made transperat to hide the symobl boundary
export const const_address_parcel_graphic_symbol = {
  type: "simple-fill",
  color: [63, 81, 181, 0],
  outline: {
    color: [63, 81, 181, 0],
    width: 0,
  },
};

export const const_not_found_point_symbol = {
  type: "simple-marker",
  path:
    "M79,32c0-15.5-12.5-28-28-28s-28,12.5-28,28c0,4.4,1,8.5,2.9,12.3h0c0,0,0.1,0.2,0.3,0.6c0.2,0.4,0.4,0.7,0.6,1    c0.8,1.4,1.8,3.3,2.3,4.1c2.7,4.2,5.9,9.6,7.9,12.9c2.8,4.5,7.4,14,9.3,18.9c1.4,3.5,4.7,14.4,4.7,14.4s3.4-10.8,4.7-14.4    c1.9-4.9,6.5-14.5,9.3-18.9c2.1-3.3,5.2-8.7,7.9-12.9c0.5-0.8,1.6-2.7,2.3-4.1c0.2-0.3,0.4-0.7,0.6-1c0.2-0.4,0.3-0.6,0.3-0.6h0    C78,40.6,79,36.4,79,32z M51,50.7c-10.3,0-18.6-8.3-18.6-18.6c0-10.3,8.3-18.6,18.6-18.6c10.3,0,18.6,8.3,18.6,18.6    C69.7,42.3,61.3,50.7,51,50.7z",
  size: "32px",
  color: "#f50057",
  outline: { color: "#f50057", width: "1px" },
};

export const const_address_line_street_symbol = {
  type: "simple-line",
  color: [34, 106, 188, 0.5],
  width: 3,
};

//make trasperant to hide the bouandry
export const const_address_area_symbol = {
  type: "simple-fill",
  color: [63, 81, 181, 0],
  outline: {
    color: [63, 81, 181, 0],
    width: 1,
  },
};

export const const_txt_symobl_for_graphics = {
  // angle: 90,
  color: "black",
  font: {
    // autocast as new Font()
    family: "Josefin Slab", //Josefin Slab Just Another Hand
    size: 15,
    weight: "bold",
  },
  // haloColor: "#f50057",
  haloSize: 1,
  horizontalAlignment: "justify",
  verticalAlignment: "bottom",
};

export const const_wrong_Pin = {
  type: "simple-marker",
  path:
    "M46.54,88.709C40.7,95.631,36.184,100,36.184,100S0,64.987,0,36.185C0,16.2,16.2,0,36.184,0s36.184,16.2,36.184,36.185   c0,1.855-0.151,3.736-0.433,5.632c-3.555,0.051-7.102,0.716-10.469,2c0.729-2.417,1.121-4.979,1.121-7.632   c0-14.583-11.821-26.404-26.404-26.404S9.78,21.602,9.78,36.185c0,14.582,11.822,26.403,26.404,26.403   c2.654,0,5.216-0.393,7.632-1.121C40.429,70.353,41.337,80.5,46.54,88.709z M100,72.371C100,87.63,87.63,100,72.371,100   c-15.26,0-27.63-12.37-27.63-27.629c0-15.26,12.37-27.63,27.63-27.63C87.63,44.741,100,57.111,100,72.371z M84.484,79.927   l-7.557-7.556l7.557-7.557l-4.558-4.558l-7.556,7.556l-7.557-7.555l-4.557,4.557l7.555,7.557l-7.556,7.556l4.558,4.558l7.557-7.557   l7.556,7.557L84.484,79.927z",
  size: "32px",
  color: "red",
  outline: { color: "red", width: "1px" },
};

export const const_issue_incorrect_address_point = {};

export const const_missing_address_point = {};

export const const_damage_sinage_point = {};

export const const_missing_sinage_point = {};

export const const_isssue_address_point = {
  type: "simple-marker",
  path:
    "M79,32c0-15.5-12.5-28-28-28s-28,12.5-28,28c0,4.4,1,8.5,2.9,12.3h0c0,0,0.1,0.2,0.3,0.6c0.2,0.4,0.4,0.7,0.6,1    c0.8,1.4,1.8,3.3,2.3,4.1c2.7,4.2,5.9,9.6,7.9,12.9c2.8,4.5,7.4,14,9.3,18.9c1.4,3.5,4.7,14.4,4.7,14.4s3.4-10.8,4.7-14.4    c1.9-4.9,6.5-14.5,9.3-18.9c2.1-3.3,5.2-8.7,7.9-12.9c0.5-0.8,1.6-2.7,2.3-4.1c0.2-0.3,0.4-0.7,0.6-1c0.2-0.4,0.3-0.6,0.3-0.6h0    C78,40.6,79,36.4,79,32z M51,50.7c-10.3,0-18.6-8.3-18.6-18.6c0-10.3,8.3-18.6,18.6-18.6c10.3,0,18.6,8.3,18.6,18.6    C69.7,42.3,61.3,50.7,51,50.7z",
  size: "32px",
  color: "#cc3300",
  outline: { color: "#cc3300", width: "1px" },
};
